import { useState, useEffect } from 'react';
import { getReferences, Reference } from '../../../data/referencesData';

export default function References() {
  const [references, setReferences] = useState<Reference[]>([]);

  useEffect(() => {
    setReferences(getReferences());
  }, []);

  if (references.length === 0) {
    return (
      <section id="references" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nos Références Clients
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Ils nous font confiance pour protéger leurs espaces et garantir un environnement sain
            </p>
          </div>
          <div className="text-center py-16 text-gray-400">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-4-line text-5xl"></i>
            </div>
            <p className="text-lg font-medium">Les références seront ajoutées prochainement</p>
          </div>
          <StatsBar />
        </div>
      </section>
    );
  }

  return (
    <section id="references" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Références Clients
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ils nous font confiance pour protéger leurs espaces et garantir un environnement sain
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {references.map((reference) => (
            <div
              key={reference.id}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-20 h-20 mx-auto mb-4 rounded-lg overflow-hidden bg-white flex items-center justify-center p-2 shadow-sm">
                {reference.logo ? (
                  <img
                    src={reference.logo}
                    alt={reference.name}
                    className="w-full h-full object-contain object-top"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-teal-50 rounded">
                    <i className="ri-building-line text-2xl text-teal-500"></i>
                  </div>
                )}
              </div>
              <div className="text-center">
                <span className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-xs font-semibold rounded-full mb-3">
                  {reference.category}
                </span>
                <h3 className="text-base font-bold text-gray-900 mb-2">{reference.name}</h3>
                {reference.description && (
                  <p className="text-xs text-gray-600 leading-relaxed">{reference.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        <StatsBar />
      </div>
    </section>
  );
}

function StatsBar() {
  return (
    <div className="mt-16 text-center">
      <div className="inline-flex items-center gap-12 bg-gradient-to-r from-teal-50 to-green-50 rounded-xl px-12 py-8">
        <div className="text-center">
          <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
          <div className="text-sm text-gray-600">Clients Satisfaits</div>
        </div>
        <div className="w-px h-16 bg-gray-300"></div>
        <div className="text-center">
          <div className="text-4xl font-bold text-teal-600 mb-2">15+</div>
          <div className="text-sm text-gray-600">Années d&apos;Expérience</div>
        </div>
        <div className="w-px h-16 bg-gray-300"></div>
        <div className="text-center">
          <div className="text-4xl font-bold text-teal-600 mb-2">98%</div>
          <div className="text-sm text-gray-600">Taux de Satisfaction</div>
        </div>
      </div>
    </div>
  );
}
